/* eslint-disable react/prop-types */
/* eslint-disable react/react-in-jsx-scope */
import { useState, useEffect, useRef } from "react";
import { Input } from "reactstrap";

const SearchField = (props) => {
  const [searchValue, setSearchValue] = useState(props.filterParams?.search || '');
  const timerRef = useRef(null);

  useEffect(() => {
    setSearchValue(props.filterParams?.search || '');
  }, [props.filterParams?.search]);

  useEffect(() => {
    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, []);

  const handleSearchChange = (event) => {
    const value = event.target.value;
    setSearchValue(value);

    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }

    if (!value || !value.trim()) {
      if (props.fetchData) {
        props.fetchData({
          ...props.filterParams,
          search: '',
          page: 1,
          currentPage: 1,
        });
      }
      return;
    }

    timerRef.current = setTimeout(() => {
      const newFilterParams = {
        ...props.filterParams,
        search: value.trim(),
        page: 1,
        currentPage: 1,
      };

      if (props.fetchData) {
        props.fetchData(newFilterParams);
      }
    }, 250);
  };

  return (
    <div className="search-max-width mb-4">
      <div className="form-icon left">
        <Input
          type="search"
          className="form-control form-control-icon"
          value={searchValue}
          onChange={handleSearchChange}
          onSearch={handleSearchChange}
          id="iconrightInput"
          placeholder="Search...."
        />
        <i className="ri-search-line"></i>
      </div>
    </div>
  );
};

export default SearchField;
